import { Chips } from "primereact/chips";
import { useState, useEffect } from "react";
import { Row, Col, Overlay, Popover } from "react-bootstrap";
import "./ChipsControl.css";

const ChipsControl = (props: any) => {
  const [values, setValues] = useState<any[]>(props.Values ? props.Values : []);

  const [showHelper, setShowHelper] = useState(false);
  const [targetHelper, setTargetHelper] = useState(null);

  useEffect(() => {
    setValues(props.Values ? props.Values : []);
  }, [props.Values]);

  const handlerClickHelper = (e: any) => {
    setShowHelper(!showHelper);
    setTargetHelper(e.target);
  };

  const onChangeValue = (e: any) => {
    if (props.onChipChange) props.onChipChange(e);

    setValues(e.value);
  };

  const isDisabled = props.disabled;

  return (
    <>
      <Row className={`${!props.Title ? "" : ""}`}>
        <Col>
          <span
            className={`font-label-form form-label ${
              !props.Title ? "d-none" : ""
            }`}
          >
            {props.Title || ""}
            {props.Helper ? (
              <>
                <img
                  src={"img/questionmarkicon.png"}
                  alt="questionmark"
                  className="dashboard-questionmark-size"
                  onClick={(e) => handlerClickHelper(e)}
                />
                <Overlay
                  show={showHelper}
                  target={targetHelper}
                  placement={"right"}
                >
                  <Popover>
                    <Popover.Body>{props.Helper || ""}</Popover.Body>
                  </Popover>
                </Overlay>
              </>
            ) : (
              <></>
            )}
          </span>
        </Col>
      </Row>
      <span className={`w-100 ${isDisabled ? "chips-disabled" : ""}`}>
        <Chips
          value={values}
          placeholder={props.placeholder || ""}
          onChange={(e: any) => onChangeValue(e)}
          separator=","
          className={`w-100 ${isDisabled ? "chips-disabled" : ""}`}
          disabled={isDisabled}
        />
      </span>
    </>
  );
};

export default ChipsControl;
